import { createAction } from "redux-actions";

export const CHART_SLIDE_DECK_BUTTON_CLICKED = "CHART_SLIDE_DECK_BUTTON_CLICKED";
export const chartSlideDeckButtonClicked = createAction(CHART_SLIDE_DECK_BUTTON_CLICKED);
export const onExportDefault = dispatch => (chart, title) => () => {
  const svg = chart.svgString();

  dispatch(chartSlideDeckButtonClicked({ chartSvg: svg, title: title }));
};

export const CANCEL_SLIDE_DECK_BUTTON_CLICKED = "CANCEL_SLIDE_DECK_BUTTON_CLICKED";
export const cancelSlideDeckButtonClicked = createAction(CANCEL_SLIDE_DECK_BUTTON_CLICKED);

export const SUBMIT_SLIDE_DECK_BUTTON_CLICKED = "SUBMIT_SLIDE_DECK_BUTTON_CLICKED";
export const submitSlideDeckButtonClicked = createAction(SUBMIT_SLIDE_DECK_BUTTON_CLICKED);

export const SLIDE_DECK_RADIO_BUTTON_CLICKED = "SLIDE_DECK_RADIO_BUTTON_CLICKED";
export const slideDeckRadioButtonClicked = createAction(SLIDE_DECK_RADIO_BUTTON_CLICKED);

export const SLIDE_DECK_TEXT_CHANGE = "SLIDE_DECK_TEXT_CHANGE";
export const slideDeckTextChange = createAction(SLIDE_DECK_TEXT_CHANGE);

export const NEW_VALUE = "NEW_VALUE";

export const SD_LOADING_OPTIONS_STARTED = "SD_LOADING_OPTIONS_STARTED";
export const SD_OPTIONS_LOADED = "SD_OPTIONS_LOADED";
export const SD_LOADING_OPTIONS_FINISHED = "SD_LOADING_OPTIONS_FINISHED";

export const SD_SUBMIT_STARTED = "SD_SUBMIT_STARTED";
export const SD_SUBMITTED = "SD_SUBMITTED";
export const SD_SUBMIT_FINISHED = "SD_SUBMIT_FINISHED";
